import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CardAlamat from '../CardAlamat';
import TextInput from '../../../../../../components/TextInput';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  createAccountAddress,
  deleteAccountAddress,
  setShippingAddress,
  updateAccountAddress,
} from '../../../../../../redux/actions/account';
import { formatCurrency } from '../../../../../../constants/utility';
import {
  fetchShipping,
  fetchGudangStok,
  setFormOrder,
} from '../../../../../../redux/actions/transaction';
import ModalOverDemand from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import ModalAlamat from '../../../../../../components/Modal/ModalAlamat';
import { toast } from 'react-toastify';
import Modals from 'react-bootstrap/Modal';
const FormDelivery = ({ onNavigateBack }) => {
  const [formAddress, setFormAddress] = useState(null);
  const {
    register,
    watch,
    formState,
    setValue,
    control,
    errors,
  } = useForm();
  const { address } = useSelector((state) => state.account);
  const { formOrder, shipping, gudang } = useSelector(
    (state) => state.transaction
  );
  const dispatch = useDispatch();
  const [selectedSearchAddress, setSelectedSearchAddress] = useState('');

  const watchGudang = watch('gudang_id');
  const watchJenisPengiriman = watch('jenis_pengiriman');

  useEffect(() => {
    if (gudang?.length === 1) setValue('gudang_id', gudang[0]?.public_id);
  }, [gudang, setValue]);

  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [optEkspedisi, setOptEkspedisi] = useState([]);
  const [optLayanan, setOptLayanan] = useState([]);
  const watchEkspedisi = watch('ekspedisi');
  const watchLayanan = watch('layanan');
  const [subsidiOngkir, setSubsidiOngkir] = useState(null);
  const [show, setShow] = useState(true);

  const [info, setInfo] = useState(true)
  const [isConfirm, setIsConfirmed] = useState(false)

  const submit = (data, action) => {
    if (action === "delete") {
      dispatch(deleteAccountAddress(data.public_id));
      dispatch(setFormOrder(tempDeletedAddress))
      setModal(false);
      return;
    }



    if (data.public_id && data.public_id !== "") {
      dispatch(updateAccountAddress(data.public_id, data));
      setSelected(null)
    } else {
      dispatch(createAccountAddress(data));
    }
    setModal(false);
    setSelectedSearchAddress(null);
  };

  const closeForm = () => {
    setIsOpen(false);
    setFormAddress(null);
  };

  const closeModal = () => {
    setModal(false);
  };

  const [selected, setSelected] = useState(null);
  const [carts, setCarts] = useState([]);

  useEffect(() => {
    setCarts(formOrder?.steps?.find((a) => a.name === 'item')?.data);
    // setSelected(formOrder?.steps?.find((a) => a.name === 'delivery')?.data);
    const deliv = formOrder?.steps?.find((a) => a.name === 'delivery')?.data;

    if (deliv) {
      if (deliv.pickup_store !== undefined)
        setValue(
          'jenis_pengiriman',
          deliv?.pickup_store === true ? 'pickup' : 'delivery'
        );
      setValue('gudang_id', deliv.gudang?.public_id);
    }
  }, [formOrder]);

  const onSelectAlamat = (data) => {
    setSelected(data);
    setModal(false);
    const tmp = {
      ...formOrder,
      steps: formOrder?.steps?.map((a) => {
        if (a.name === 'delivery') {
          return {
            ...a,
            passed: false,
            data: {
              ...data,
              gudang: gudang?.find((a) => a.public_id === watchGudang, null),
            },
          };
        }
        return a;
      }, []),
    };
    dispatch(setFormOrder(tmp));
  };

  useEffect(() => {
    if (
      !selected ||
      carts?.length === 0 ||
      !watchGudang ||
      !gudang ||
      !watchJenisPengiriman ||
      watchJenisPengiriman !== 'delivery'
    )
      return;
    const origin = gudang?.find(
      (a) => a.public_id === watchGudang,
      null
    )?.id_alamat;
    if (!origin) return;

    setOptEkspedisi([]);
    setOptLayanan([]);
    dispatch(
      fetchShipping({
        originType: 'subdistrict',
        origin: origin,
        // destination_id: selected?.alamat_domestic?.id_alamat,
        kelurahan_id: selected?.kelurahan_id,
        // id_alamat: selected?.alamat_domestic?.id,
        weight: carts?.reduce((a, b) => a + b.qty * b.berat, 0),
        gudang_id: watchGudang,
        bv: carts?.reduce((a, b) => a + b.value * b.qty, 0),
      })
    );

  }, [
    selected,
    carts,
    watchGudang,
    gudang,
    watchJenisPengiriman,
    dispatch,
  ]);

  useEffect(() => {
    setValue('ekspedisi', '');
    setValue('layanan', '');
    dispatch(setFormOrder(tempDeletedAddress))
  }, [watchGudang, watchJenisPengiriman]);

  function getBestCourier(shipping) {
    if (!shipping || !Array.isArray(shipping.courier)) {
      return null;
    }

    // Fungsi bantu untuk parsing etd (ambil nilai terendah dari string etd)
    function parseEtd(etd) {
      if (typeof etd !== "string") return Infinity;
      const numbers = etd.match(/\d+/g);
      return numbers && numbers.length > 0 ? parseInt(numbers[0], 10) : Infinity;
    }

    // Mapping ekspedisi dengan etd yang diparsing
    const enrichedCouriers = shipping.courier.map(courier => ({
      ...courier,
      etdDays: parseEtd(courier.etd)
    }));

    // Filter hanya yang etdDays >= 1
    const validCouriers = enrichedCouriers.filter(c => c.etdDays > 1);
    if (validCouriers.length === 0) {
      return null;
    }

    // Cari estimasi pengiriman tercepat dari yang valid
    const minEtd = Math.min(...validCouriers.map(c => c.etdDays));

    // Filter kandidat yang punya estimasi tercepat
    const fastestCouriers = validCouriers.filter(c => c.etdDays === minEtd);

    // Dari yang tercepat, ambil yang paling murah
    const bestCourier = fastestCouriers.reduce((prev, curr) =>
      curr.cost < prev.cost ? curr : prev
    );

    return bestCourier;
  }

  useEffect(() => {
    const bestShippingOption = getBestCourier(shipping);
    if (bestShippingOption && bestShippingOption.code && bestShippingOption.name) {
      setOptEkspedisi([
        {
          value: bestShippingOption.code,
          label: bestShippingOption.name,
          data: bestShippingOption
        }
      ]);
    } else {
      setOptEkspedisi([]);
    }


    const { values, ...datasub } = shipping?.subsidi || {};
    const isGudangSub = values?.find(
      (sub) => sub?.gudang?.public_id === watchGudang
    );

    if (!isGudangSub) return;

    const totalBv = carts?.reduce((a, b) => a + b.qty * b.value, 0);
    const qualifiedBv = isGudangSub.values
      .sort((a, b) => b.bv - a.bv, [])
      .find((a) => totalBv >= a.bv);

    if (!qualifiedBv) return;

    setSubsidiOngkir({
      ...datasub,
      ...isGudangSub,
      nominal:
        datasub?.jenis === 'PERSENTASE'
          ? Math.floor(
            (carts?.reduce((a, b) => a + b.qty * b.dpp, 0) *
              (Number(qualifiedBv.value) / 100)) /
            1000
          ) * 1000
          : Number(qualifiedBv.value),
    });
  }, [shipping]);

  const [myEkspedisi, setMyEkspedisi] = useState(null);

  useEffect(() => {
    setValue('layanan', '');
    const optLayanan = optEkspedisi?.map((layanan) => {
      if (layanan.value === watchEkspedisi?.value) {
        const cost = layanan.data.cost
        const potongan = subsidiOngkir
          ? Math.min(subsidiOngkir.nominal, cost)
          : 0;
        return {
          value: layanan?.data?.service,
          label: (
            <div>
              <div>
                {layanan.data.service} - {layanan.data.description} - {layanan.data.etdDays} hari
              </div>
              <div>
                {subsidiOngkir ? (
                  <>
                    <strike>{formatCurrency(cost)}</strike>&nbsp;
                    {formatCurrency(cost - potongan)}
                  </>
                ) : (
                  formatCurrency(cost)
                )}
              </div>
            </div>
          ),
          data: {
            ...layanan,
            potongan,
          },
        }
      }
      return []
    })

    setOptLayanan(optLayanan)
    setMyEkspedisi(
      shipping?.ekspedisi?.find((a) => a.kode === watchEkspedisi?.value)
    );
  }, [watchEkspedisi, optEkspedisi, setValue, shipping]);

  useEffect(() => {
    setValue(
      'is_asuransi',
      (myEkspedisi?.asuransi_fix || myEkspedisi?.asuransi_persen) &&
        myEkspedisi.wajib_asuransi
        ? true
        : false
    );
  }, [myEkspedisi, setValue]);

  useEffect(() => {
    setValue('ekspedisi', '')
    setValue('layanan', '')
  }, [selected, optEkspedisi, setValue]);

  const onNext = () => {
    const tmp = {
      ...formOrder,
      activeIndex: formOrder.activeIndex + 1,
      activeStep: formOrder.steps.find(
        (a, i) => i === formOrder.activeIndex + 1
      )?.name,
      steps: formOrder?.steps?.map((a) => {
        if (a.name === 'delivery') {
          const ispickup = watchJenisPengiriman === 'pickup';
          return {
            ...a,
            passed: true,
            data: {
              ...a.data,
              pickup_store: ispickup,
              gudang: gudang?.find((a) => a.public_id === watchGudang, null),
              kodeKurir: optEkspedisi?.find(
                (a) => a.value === watchEkspedisi?.value
              )?.value,
              namaKurir: optEkspedisi?.find(
                (a) => a.value === watchEkspedisi?.value
              )?.label,
              kodeLayanan: optLayanan?.find(
                (a) => a.value === watchLayanan?.value
              )?.value,
              namaLayanan: optLayanan?.find(
                (a) => a.value === watchLayanan?.value
              )?.data?.data?.service,
              ongkir: optLayanan?.find((a) => a.value === watchLayanan?.value)
                ?.data?.data?.cost,
              myEkspedisi: myEkspedisi,
              is_asuransi: watch('is_asuransi'),
              potonganOngkir: optLayanan?.find(
                (a) => a.value === watchLayanan?.value
              )?.data?.potongan,
              subsidiOngkir,
            },
          };
        }
        return a;
      }, []),
    };

    dispatch(setFormOrder(tmp));
  };

  const disabled =
    !watchGudang ||
    !watchJenisPengiriman ||
    (watchJenisPengiriman === 'delivery' &&
      (!watchEkspedisi || !watchLayanan || !selected));

  useEffect(() => {
    if (carts?.length && watchJenisPengiriman) {
      dispatch(
        fetchGudangStok({
          carts: carts.map(({ public_id: id, qty }) => ({ id, qty })),
          is_online_pickup: watchJenisPengiriman === 'delivery' ? 1 : null,
          is_offline_pickup: watchJenisPengiriman === 'pickup' ? 1 : null,
        })
      );
    }
  }, [dispatch, carts, watchJenisPengiriman]);

  useEffect(() => {
    if (selectedSearchAddress) {
      setValue('provinsi', selectedSearchAddress?.provinsi)
      setValue('kota', selectedSearchAddress?.kota)
      setValue('kecamatan', selectedSearchAddress?.kecamatan)
      setValue('kelurahan', selectedSearchAddress?.kelurahan)
      setValue('kode_pos', selectedSearchAddress?.kode_pos)
    } else {
      dispatch(setShippingAddress(null))
      setValue('provinsi', '')
      setValue('kota', '')
      setValue('kecamatan', '')
      setValue('kelurahan', '')
      setValue('kode_pos', '')
    }
  }, [selectedSearchAddress])

  const tempDeletedAddress = {
    ...formOrder,
    steps: formOrder?.steps?.map((a) => {
      if (a.name === 'delivery') {
        return {
          ...a,
          data: null
        };
      }
      return a;
    }, []),
  };

  useEffect(() => {
    if (gudang && gudang.length > 0) {
      const cekIsDefault = address.rows.find((val) => val.is_default === true);
      if (cekIsDefault) {
        setSelected(cekIsDefault);
      }
    }
  }, [address, gudang]);


  useEffect(() => {
    if (selected) {
      const tmp = {
        ...formOrder,
        steps: formOrder?.steps?.map((a) => {
          if (a.name === 'delivery') {
            return {
              ...a,
              passed: false,
              data: {
                ...selected,
                gudang: gudang?.find((a) => a.public_id === watchGudang, null),
              },
            };
          }
          return a;
        }, []),
      };
      dispatch(setFormOrder(tmp));
    }
  }, [selected, gudang])

  const expiredItems = carts
    ?.flatMap(cart =>
      cart.item_barangs
        ?.filter(barang => barang.item?.show_expired_notif === true)
        .map(barang => ({
          paketNama: cart.nama,
          itemNama: barang.item.nama,
          text_notif: barang.item.text_notif,
        }))
    ) || [];


  return (
    <>
      <h5 className="border-bottom py-2 mb-2" style={{ color: '#3d405c' }}>
        Pilih Metode Pengiriman
      </h5>
      {watch('jenis_pengiriman') === 'pickup' ? (
        <div className="alert alert-warning">
          <strong>Pengiriman Pickup Store!</strong>
          <div>
            Maksimal pengambilan 14 hari dari tanggal transaksi /
            tanggal invoice
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="card mb-2">
        <div className="card-body">
          <div className="mb-4">
            <TextInput
              layout="vertical"
              label="Jenis Pengiriman"
              type="radio"
              name="jenis_pengiriman"
              defaultValue={watch('jenis_pengiriman')}
              register={register}
              errors={formState.errors}
              options={[
                {
                  value: 'delivery',
                  label: 'Pengiriman Online',
                  sublabel: 'Paket Dikirim menggunakan jasa kurir/ekspedisi',
                },
                {
                  value: 'pickup',
                  label: 'Pickup Store',
                  sublabel: 'Paket diambil langsung di kantor',
                },
              ]}
            />
          </div>
          <div
            className="mb-4"
            hidden={
              watchJenisPengiriman === null ||
              watchJenisPengiriman === undefined
            }>
            <TextInput
              layout="vertical"
              label={
                watchJenisPengiriman === 'delivery'
                  ? 'Asal Pengiriman'
                  : 'Lokasi Pengambilan'
              }
              type="radio-kebawah"
              name="gudang_id"
              defaultValue={watch('gudang_id')}
              register={register}
              errors={formState.errors}
              options={gudang?.map((a) => {
                return {
                  value: a?.public_id,
                  label: a?.nama,
                  sublabel: a?.lokasi,
                };
              }, [])}
            />
            {gudang?.length === 0 ? (
              <div className="alert alert-warning">
                Paket/Item yang Anda pilih tidak tersedia, Pilih jenis
                pengiriman lain.
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
      {watchJenisPengiriman === 'delivery' ? (
        <>
          <div className="card mb-2">
            <div className="card-body">
              {!selected ? (
                'Belum ada alamat pengiriman dipilih'
              ) : (
                <>
                  <div>
                    {selected?.nama} ({selected?.phone}){' '}
                    <span className="badge badge-info">{selected?.label}</span>
                  </div>
                  <div>
                    {selected?.alamat}. Kecamatan {selected?.kecamatan},
                    Kabupaten/Kota {selected?.kota}, Propinsi{' '}
                    {selected?.provinsi}. Kode Pos {selected?.kode_pos}
                  </div>
                </>
              )}
              <div className="mt-2">
                <button
                  type="button"
                  className="btn btn-primary-f mb-2 btn-sm"
                  onClick={() => {
                    if (address?.rows?.length > 0) {
                      setModal(true);
                    } else {
                      setIsOpen(true);
                    }
                  }}>
                  {address?.rows?.length > 0 ? 'Pilih Alamat' : 'Tambah Alamat'}
                </button>
              </div>
            </div>
          </div>
          {selected && (
            <div className="card mb-2">
              <div className="card-body">
                <div className="row">
                  <div
                    className="col-sm-12 col-md-3"
                    style={modal || isOpen || show ? {} : { zIndex: 9999 }}>
                    <Controller
                      name={'ekspedisi'}
                      control={control}
                      // rules={{ required: true }}
                      render={({ field }) => (
                        <TextInput
                          name={'ekspedisi'}
                          label="Ekspedisi"
                          type="react-select"
                          placeholder="Ekspedisi"
                          register={register}
                          errors={errors}
                          field={field}
                          options={optEkspedisi}
                          validations={{ required: true }}
                        />
                      )}
                    />
                  </div>
                  <div
                    className="col-sm-12 col-md-5"
                    style={modal || isOpen || show ? {} : { zIndex: 9998 }}>
                    <Controller
                      name={'layanan'}
                      control={control}
                      // rules={{ required: true }}
                      render={({ field }) => (
                        <TextInput
                          name={'layanan'}
                          label="Layanan"
                          type="react-select"
                          placeholder="Layanan"
                          register={register}
                          errors={errors}
                          field={field}
                          options={optLayanan}
                          validations={{ required: true }}
                        />
                      )}
                    />
                  </div>
                  {myEkspedisi ? (
                    <div className="col-sm-12 col-md-3">
                      {myEkspedisi?.asuransi_fix ||
                        myEkspedisi?.asuransi_persen ? (

                        <TextInput
                          disabled={myEkspedisi?.wajib_asuransi}
                          layout="vertical"
                          label={`Asuransi ${myEkspedisi?.wajib_asuransi
                            ? '(Wajib)'
                            : '(Opsional)'
                            }`}
                          type="switch"
                          name="is_asuransi"
                          placeholder=""
                          register={register}
                          errors={formState.errors}
                          value={watch('is_asuransi')}
                          options={[
                            {
                              value: true,
                              label: `Ya, ${formatCurrency(
                                carts?.reduce(
                                  (a, b) => a + b.qty * b.harga,
                                  0
                                ) *
                                (myEkspedisi?.asuransi_persen / 100) +
                                myEkspedisi?.asuransi_fix
                              )}`,
                            },
                            { value: false, label: 'Tidak' },
                          ]}
                        // validations={{ required: "Pilih Layanan" }}
                        />
                      ) : (
                        <div>
                          <label className="font-weight-bold">Asuransi</label>
                          <div
                            style={{ fontSize: '0.8rem' }}
                            className="italic">
                            <i>
                              Tidak ada opsi asuransi untuk ekpedisi{' '}
                              {myEkspedisi?.nama}
                            </i>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        ''
      )}

      {
        carts?.length > 0 &&
        carts.some(cart =>
          cart.item_barangs?.some(barang => barang.item.show_expired_notif === true)
        ) && (
          <Modals show={info}>
            <Modals.Header style={{ background: '#52567a' }}>
              <Modals.Title style={{ color: 'white' }}>
                <div style={{ fontSize: '20px' }}>
                  <i className='fa fa-info mr-3'></i>
                  <strong>Pesan Informasi</strong>
                </div>
              </Modals.Title>
            </Modals.Header>

            <Modals.Body>
              <div style={{ marginBottom: "12px", fontWeight: "bold" }}>
                Item dalam paket berikut memiliki expired date :
              </div>

              {expiredItems.map((item, index) => (
                <div
                  key={index}
                  style={{
                    color: "red",
                    marginBottom: "8px",
                    paddingLeft: "10px",
                    borderLeft: "3px solid red",
                  }}
                >
                  <div>
                    <strong>Paket:</strong>  {item.paketNama}
                  </div>
                  <div style={{ fontSize: "13px" }}>
                    <strong>
                      {item.text_notif
                        ?.split(/\n|;/)
                        .map((text, index) => (
                          <div key={index} style={{ marginLeft: "20px" }}>
                            {text.trim()}
                          </div>
                        ))}
                    </strong>

                  </div>
                </div>
              ))}

              {/* ✅ CHECKBOX KONFIRMASI */}
              <div className="mt-4">
                <label style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={isConfirm}
                    onChange={(e) => setIsConfirmed(e.target.checked)}
                    style={{ marginRight: "8px" }}
                  />
                  Saya telah membaca dan menyetujui informasi di atas
                </label>
              </div>
            </Modals.Body>


            <Modals.Footer>
              <Button variant='secondary' onClick={onNavigateBack}>
                Batal
              </Button>
              <Button variant='primary' onClick={() => isConfirm && setInfo(false)}>
                OK
              </Button>
            </Modals.Footer>
          </Modals>
        )
      }



      {/* {
        carts?.[0]?.nama?.includes('Seolyiming') && (
          <ModalOverDemand show={show}>
            <ModalOverDemand.Header style={{ background: '#52567a' }}>
              <ModalOverDemand.Title style={{ color: 'white' }}>
                <div style={{ fontSize: '20px' }}>
                  <i className='fa fa-info mr-3'> </i>
                  <strong>Pesan Informasi</strong>
                </div>
              </ModalOverDemand.Title>
            </ModalOverDemand.Header>
            <ModalOverDemand.Body>
              <strong>Paket {carts?.[0]?.nama}!</strong>
              <div>
                Transaksi ini masuk dalam waiting list Pre-Order
              </div>
            </ModalOverDemand.Body>
            <ModalOverDemand.Footer>
              <Button variant='secondary' onClick={() => setShow(false)} size="sm">
                Tutup
              </Button>
            </ModalOverDemand.Footer>
          </ModalOverDemand>
        )
      } */}

      <table className="table" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Paket</th>
            <th className="text-right">Qty</th>
            <th className="text-right">BV</th>
            <th className="text-right">Harga</th>
          </tr>
        </thead>
        <tbody>
          {carts?.map((item, key) => {
            return (
              <tr key={key}>
                <td>{item.nama}</td>
                <td className="text-right">{item.qty}</td>
                <td className="text-right">{item.qty * item.value}</td>
                <td className="text-right">
                  {formatCurrency(item.harga * item.qty)}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th className="text-right">Total</th>
            <th className="text-right">
              {carts?.reduce((a, b) => a + b.qty, 0)}
            </th>
            <th className="text-right">
              {carts?.reduce((a, b) => a + b.qty * b.value, 0)}
            </th>
            <th className="text-right">
              {formatCurrency(carts?.reduce((a, b) => a + b.qty * b.harga, 0))}
            </th>
          </tr>
        </tfoot>
      </table>
      <hr />
      <div className="stepper-navigation">
        <div className="d-flex justify-content-center">
          <button
            type="button"
            className="btn btn-outline-secondary btn-md font-weight-bold mr-1 px-10 flex-grow-1"
            onClick={() => onNavigateBack()}>
            <i className="fas fa-chevron-left mr-4"></i>
            Prev
          </button>
          <button
            onClick={() => onNext()}
            disabled={disabled}
            type="submit"
            className="btn btn-primary-f btn-md font-weight-bold ml-1 px-10 flex-grow-1">
            Next
            <i className="fas fa-chevron-right ml-4"></i>
          </button>
        </div>
      </div>

      {
        isOpen &&
        <ModalAlamat
          toggle={() => closeForm()}
          modal={isOpen}
          data={formAddress}
          submit={submit}
        />
        // (<ModalAlamat
        //   toggle={() => closeForm()}
        //   modal={isOpen}
        //   setSelectedRow={onSelectAlamat}
        //   selectedRow={formAddress}
        //   selectedSearchAddress={selectedSearchAddress}
        //   setSelectedSearchAddress={setSelectedSearchAddress}
        //   submit={submit}
        // defaultValues={{
        //   id_alamat_domestic: null,
        //   nama: "",
        //   label: "",
        //   alamat: "",
        //   kecamatan: "",
        //   kota: "",
        //   phone: "",
        //   kode_pos: "",
        //   public_id: "",
        //   provinsi: "",
        //   kelurahan: "",
        // }}
        // />)
      }


      {/* modal pilih alamat */}
      <Modal
        toggle={() => closeModal()}
        isOpen={modal}
        centered={true}
        size={'lg'}>
        <ModalHeader
          toggle={() => closeModal()}
          close={
            <div className="btn close" onClick={() => closeModal()}>
              ×
            </div>
          }>
          Pilih Alamat
        </ModalHeader>
        <ModalBody>
          <div className="modal-body">
            <button
              type="button"
              className="btn mb-2 btn-sm text-white"
              style={{ backgroundColor: "#4682A9" }}
              onClick={() => {
                setIsOpen(true);
                setSelectedSearchAddress(null)
                setSelected(null)
              }}>
              Tambah Alamat
            </button>
            <div className="list-group mb-4">
              {address?.rows?.map((item, ix) => {
                return (
                  <CardAlamat
                    key={ix}
                    data={item}
                    selected={selected}
                    onSelectAlamat={onSelectAlamat}
                    action={true}
                    setFormAddress={setFormAddress}
                    setIsOpen={setIsOpen}
                  />
                );
              })}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default FormDelivery;
